import React, { Fragment } from "react";
import { translate } from "../Services/translation";
import { currencyFormat, numberFormat } from "../Services/formatting";
import ConfigButton from "../Containers/ConfigButton.container";
import ProductIcons from "./ProductIcons";


const sameCategory = (item, index, array) => (index > 0 && array[index - 1].category === array[index].category) || item.showAll;
const QuickSearchResult = ({ result, selectedItem, searchUrl, isAuthedicated }) => (
  <div className="quick-search-result-wrapper">
    {result &&
      result
        .map((o) => o.category)
        .filter((value, index, self) => self.indexOf(value) === index)
        .map((category, kindex) => {         
          return (
            <Fragment key={`RESULT-${kindex}`}>
              {(category === translate("searchcategory.product") || category === "js.searchcategory.product" )&& (
                <table className="quick-search-result product-list">
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th className="narrow-th"> {translate("product.weightpersalesunit")} </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {result
                      .filter((o) => o.category === category)
                      .map((item, index) => {
                        return (
                          <tr className="product__wrapper quick-search-result__item mobile-view" key={`${item.name}-${index}`}>
                            <td className="product__figure">
                              {item.isCustomerUniqueItem && (<svg className="remnant-image"><use href={`/ui/images/sprites/be-group.svg#${item.customerUniqueSvg}`}></use></svg>)}
                              
                              <a className={item.showAll ? "quick-search-result__show-all" : `quick-search-result__link ${item.url ? "" : "quick-search-result__link--disabled"}`} href={item.showAll ? searchUrl : item.url}>
                                {item.hasImage && item.imageSource && (
                                  <figure>
                                    <img className="quick-search-result__image product__image" src={item.imageSource} />
                                    {item.isCampaignProduct && isAuthedicated && (
                                      <div className="product__campaign-banner product__campaign-banner__quick-search">{translate("product.campaignbanner")}</div>
                                    )}
                                    {/* {item.isEnvironmentalFriendly && (
                                      <div className="env-tag-outer">
                                        <span className="env-tooltip--data">
                                          <span className="data-tooltip" data-tip={translate("product.environmentalfriendly.hover")} data-html="true">
                                            <svg className="enviroment-image">
                                              <use href={`/ui/images/sprites/be-group.svg#environmental-friendly`}></use> 
                                            </svg>
                                        </span>
                                      </span>
                                    </div>
                                    )} */}
                                  </figure>
                                )}
                              </a>

                              <a className={item.showAll ? "quick-search-result__show-all product-mobile-name" : `quick-search-result__link product-mobile-name ${item.url ? "" : "quick-search-result__link--disabled"}`} href={item.showAll ? searchUrl : item.url}>
                                <div>{item.name}</div>
                              </a>

                              {isAuthedicated && (
                              <span className="product__buy-button mobile-buy">
                                
                        <ConfigButton articleNumber={item.articleNumber} data-cssClass="config-btn"  label="<svg><use href='/ui/images/sprites/be-group.svg#arrow-boxed'></use></svg>" />
                                
                              </span>
                            )}
                            </td>
                            <td className="product__name">
                              <a className={item.showAll ? "quick-search-result__show-all product-name-desktop" : `quick-search-result__link product-name-desktop ${item.url ? "" : "quick-search-result__link--disabled"}`} href={item.showAll ? searchUrl : item.url}>
                                <div>{item.name}</div>
                              </a>
                              <span className="product__sku">
                                {translate("product.prefix")} {item.axItemId}
                              </span>
                              {item.externalArticleNumber && (
                                 <span className="product__exsku">
                                  {translate("product.exprefix")} {item.externalArticleNumber} 
                                  </span>
                               )}
                              {/* <span className="product__CE">
                                {item.ceMarking ? (
                                  <svg>
                                    <use href="/ui/images/sprites/be-group.svg#CE"></use>
                                  </svg>
                                ) : (
                                  ""
                                )}
                              </span> */}
                              <ProductIcons Icons={item.productIcons} />
                              <div className="mobile-more-details">
                              <span>
                                {numberFormat.format(item.weight)} {item.salesUnitPrefix}
                              </span>
                              </div>

                            </td>
                            <td className="product__weight--desktop hide-mobile-weight narrow-th">
                              <span>
                                {numberFormat.format(item.weight)} {item.salesUnitPrefix}
                              </span>
                            </td>
                            {/* {isAuthedicated && (
                              <td className="product__buy-button narrow-th">
                               
                        <ConfigButton articleNumber={item.articleNumber} data-cssClass="config-btn"  label="<svg><use href='/ui/images/sprites/be-group.svg#arrow-boxed'></use></svg>" />
                                
                              </td>
                            )} */}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              )}
              {category === "ShowAll" && (
                <div className="misc-result-wrapper">
                  <a className="button" href={searchUrl}>
                    {translate("show.all")}
                  </a>
                </div>
              )}

              {category === "NoHit" && (
                <div className="misc-result-wrapper no-result">
                  <span className="no-hit">{result[0].name}</span>
                </div>
              )}

              {category !== translate("searchcategory.product") && category !== "NoHit" && category !== "ShowAll" && (
                <div id={category} className="quick-search-list-wrapper">
                  <h4>{category}</h4>
                  <ul className="quick-search-list">
                    {result
                      .filter((o) => o.category === category)
                      .map((item, index) => {
                        return (
                          <li className="quick-search-list__list-item" key={`${item.name}-${index}`}>
                            <div className="list-item__image-wrapper">
                              {item.hasImage && item.imageSource && (
                                <figure>
                                  <img className="list-item__image" src={item.imageSource} />
                                </figure>
                              )}
                            </div>
                            <a href={item.url}>{item.name}</a>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              )}
            </Fragment>
          );
        })}

    {/*
            {result && result.map((item, index, array) => (
                <Fragment key={`${item.name}-${index}`}>
                    {item.category === 'NoHit' || sameCategory(item, index, array) ? null :
                        <caption className="quick-search-result__item quick-search-result__group-header" >{ item.category }</caption>
                    }
                    
                </Fragment>
            ))}
                </table>*/}
  </div>
);

export default QuickSearchResult;
